import creativeChallenge from 'components/challenge/types/creativeChallenge';

export default {
	'components.base.CreativeChallenge': {
		factory: creativeChallenge,
	},
};
